import moment from "moment";
import _ from "lodash";
import { getJson, Num } from "@/method";
import request from "@/method/request";
import { data1_1 } from "./data";
import { message } from "antd";

export const compute = (data) => {
  // 计算平均房价 平均收入 客房收入    淡定
  let roomRate = [
    "actual",
    "prediction",
    "budget",
    "last_year",
    "year_actual",
    "year_budget",
    "year_last_year",
    "three_actual",
    "three_budget",
    "three_last_year",
    "whole_actual",
    "whole_budget",
    "whole_last_year",
  ];
  for (let index = 0; index < roomRate.length; index++) {
    data[2][roomRate[index]] =
      Number(data[0][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[1][roomRate[index]] / Number(data[0][roomRate[index]] || "0")
          ).toFixed(4); //计算客房率
    data[3][roomRate[index]] =
      Number(data[1][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[5][roomRate[index]] / Number(data[1][roomRate[index]] || "0")
          ).toFixed(2); //计算平均房价
    data[4][roomRate[index]] =
      Number(data[0][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[5][roomRate[index]] / Number(data[0][roomRate[index]] || "0")
          ).toFixed(2); //计算平均收入
    data[8][roomRate[index]] = Number(
      (
        Number(data[5][roomRate[index]] || "0") +
        Number(data[6][roomRate[index]] || "0") +
        Number(data[7][roomRate[index]] || "0")
      ).toFixed(2),
    );
    // 客房部门利润率
    data[10][roomRate[index]] =
      Number(data[5][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[9][roomRate[index]] / Number(data[5][roomRate[index]] || "0")
          ).toFixed(4);
    // 餐饮部门利润率
    data[12][roomRate[index]] =
      Number(data[6][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[11][roomRate[index]] / Number(data[6][roomRate[index]] || "0")
          ).toFixed(4);
    // 食品成本率
    data[14][roomRate[index]] =
      Number(data[6][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[13][roomRate[index]] / Number(data[6][roomRate[index]] || "0")
          ).toFixed(4);
    // 人力资源总费用率/人力成本率
    data[16][roomRate[index]] =
      Number(data[8][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[15][roomRate[index]] / Number(data[8][roomRate[index]] || "0")
          ).toFixed(4);
    // 盈亏平衡点/总费用
    data[23][roomRate[index]] = (
      Number(data[8][roomRate[index]] || "0") -
      Number(data[21][roomRate[index]] || "0")
    ).toFixed(2);
    // 能源成本率
    data[18][roomRate[index]] =
      Number(data[8][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[17][roomRate[index]] / Number(data[8][roomRate[index]] || "0")
          ).toFixed(4);
    // 其他费用及成本
    data[19][roomRate[index]] = (
      Number(data[23][roomRate[index]] || "0") -
      Number(data[17][roomRate[index]] || "0") -
      Number(data[15][roomRate[index]] || "0") -
      Number(data[13][roomRate[index]] || "0")
    ).toFixed(2);

    // 其他费用及成本率
    data[20][roomRate[index]] =
      Number(data[8][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[19][roomRate[index]] / Number(data[8][roomRate[index]] || "0")
          ).toFixed(4);
    //  经营毛利率
    data[22][roomRate[index]] =
      Number(data[8][roomRate[index]] || "0") == 0
        ? 0
        : (
            data[21][roomRate[index]] / Number(data[8][roomRate[index]] || "0")
          ).toFixed(4);
    // 总收费
    data[28][roomRate[index]] = Number(
      (
        Number(data[27][roomRate[index]] || "0") +
        Number(data[26][roomRate[index]] || "0") +
        Number(data[25][roomRate[index]] || "0")
      ).toFixed(2),
    );
  }

  // 计算百分比
  for (let index = 0; index < data.length; index++) {
    if ([2, 10, 12, 14, 16, 18, 20, 22].includes(index)) {
      // 单独计算客房率  减法
      data[index].actual_prediction =
        Number(data[index].prediction || "0") == 0
          ? 0
          : (
              Number(data[index].actual || "0") -
              Number(data[index].prediction || "0")
            ).toFixed(4); //实际对比预测计算
      data[index].actual_budget =
        Number(data[index].budget || "0") == 0
          ? 0
          : (
              Number(data[index].actual || "0") -
              Number(data[index].budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].actual_last_year =
        Number(data[index].last_year || "0") == 0
          ? 0
          : (
              Number(data[index].actual || "0") -
              Number(data[index].last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].year_actual_budget =
        Number(data[index].year_budget || "0") == 0
          ? 0
          : (
              Number(data[index].year_actual || "0") -
              Number(data[index].year_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].year_actual_last_year =
        Number(data[index].year_last_year || "0") == 0
          ? 0
          : (
              Number(data[index].year_actual || "0") -
              Number(data[index].year_last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].three_actual_budget =
        Number(data[index].three_budget || "0") == 0
          ? 0
          : (
              Number(data[index].three_actual || "0") -
              Number(data[index].three_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].three_actual_last_year =
        Number(data[index].three_last_year || "0") == 0
          ? 0
          : (
              Number(data[index].three_actual || "0") -
              Number(data[index].three_last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].whole_actual_budget =
        Number(data[index].whole_budget || "0") == 0
          ? 0
          : (
              Number(data[index].whole_actual || "0") -
              Number(data[index].whole_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].whole_actual_last_year =
        Number(data[index].whole_last_year || "0") == 0
          ? 0
          : (
              Number(data[index].whole_actual || "0") -
              Number(data[index].whole_last_year || "0")
            ).toFixed(4); //实际对比去年
    } else if (index == 24) {
      // 边际盈利率
      data[index].actual_prediction = computeFlowThru(
        Number(data[8].actual || "0"),
        Number(data[8].prediction || "0"),
        Number(data[21].actual || "0"),
        Number(data[21].prediction || "0"),
      ).toFixed(4);
      data[index].actual_budget = computeFlowThru(
        Number(data[8].actual || "0"),
        Number(data[8].budget || "0"),
        Number(data[21].actual || "0"),
        Number(data[21].budget || "0"),
      ).toFixed(4);
      data[index].actual_last_year = computeFlowThru(
        Number(data[8].actual || "0"),
        Number(data[8].last_year || "0"),
        Number(data[21].actual || "0"),
        Number(data[21].last_year || "0"),
      ).toFixed(4);

      data[index].year_actual_budget = computeFlowThru(
        Number(data[8].year_actual || "0"),
        Number(data[8].year_budget || "0"),
        Number(data[21].year_actual || "0"),
        Number(data[21].year_budget || "0"),
      ).toFixed(4);
      data[index].year_actual_last_year = computeFlowThru(
        Number(data[8].year_actual || "0"),
        Number(data[8].year_last_year || "0"),
        Number(data[21].year_actual || "0"),
        Number(data[21].year_last_year || "0"),
      ).toFixed(4);

      data[index].three_actual_budget = computeFlowThru(
        Number(data[8].three_actual || "0"),
        Number(data[8].three_budget || "0"),
        Number(data[21].three_actual || "0"),
        Number(data[21].three_budget || "0"),
      ).toFixed(4);
      data[index].three_actual_last_year = computeFlowThru(
        Number(data[8].three_actual || "0"),
        Number(data[8].three_last_year || "0"),
        Number(data[21].three_actual || "0"),
        Number(data[21].three_last_year || "0"),
      ).toFixed(4);

      data[index].whole_actual_budget = computeFlowThru(
        Number(data[8].whole_actual || "0"),
        Number(data[8].whole_budget || "0"),
        Number(data[21].whole_actual || "0"),
        Number(data[21].whole_budget || "0"),
      ).toFixed(4);
      data[index].whole_actual_last_year = computeFlowThru(
        Number(data[8].whole_actual || "0"),
        Number(data[8].whole_last_year || "0"),
        Number(data[21].whole_actual || "0"),
        Number(data[21].whole_last_year || "0"),
      ).toFixed(4);
    } else {
      data[index].actual_prediction =
        Number(data[index].prediction || "0") == 0
          ? 0
          : (
              (data[index].actual - Number(data[index].prediction || "0")) /
              Number(data[index].prediction || "0")
            ).toFixed(4); //实际对比预测计算
      data[index].actual_budget =
        Number(data[index].budget || "0") == 0
          ? 0
          : (
              (data[index].actual - Number(data[index].budget || "0")) /
              Number(data[index].budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].actual_last_year =
        Number(data[index].last_year || "0") == 0
          ? 0
          : (
              (data[index].actual - Number(data[index].last_year || "0")) /
              Number(data[index].last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].year_actual_budget =
        Number(data[index].year_budget || "0") == 0
          ? 0
          : (
              (data[index].year_actual -
                Number(data[index].year_budget || "0")) /
              Number(data[index].year_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].year_actual_last_year =
        Number(data[index].year_last_year || "0") == 0
          ? 0
          : (
              (data[index].year_actual -
                Number(data[index].year_last_year || "0")) /
              Number(data[index].year_last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].three_actual_budget =
        Number(data[index].three_budget || "0") == 0
          ? 0
          : (
              (data[index].three_actual -
                Number(data[index].three_budget || "0")) /
              Number(data[index].three_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].three_actual_last_year =
        Number(data[index].three_last_year || "0") == 0
          ? 0
          : (
              (data[index].three_actual -
                Number(data[index].three_last_year || "0")) /
              Number(data[index].three_last_year || "0")
            ).toFixed(4); //实际对比去年

      data[index].whole_actual_budget =
        Number(data[index].whole_budget || "0") == 0
          ? 0
          : (
              (data[index].whole_actual -
                Number(data[index].whole_budget || "0")) /
              Number(data[index].whole_budget || "0")
            ).toFixed(4); //实际对比预算
      data[index].whole_actual_last_year =
        Number(data[index].whole_last_year || "0") == 0
          ? 0
          : (
              (data[index].whole_actual -
                Number(data[index].whole_last_year || "0")) /
              Number(data[index].whole_last_year || "0")
            ).toFixed(4); //实际对比去年
    }
  }

  function computeFlowThru(a, b, c, d) {
    if (a - b == 0) {
      return 0;
    } else {
      if (c - d < 0) {
        if (c - d > a - b && a - b < 0) {
          return 1 - (c - d) / (a - b);
        } else {
          if (a - b > 0) {
            return -Math.abs((c - d) / (a - b));
          } else {
            return -Math.abs((a - b - (c - d)) / (a - b));
          }
        }
      } else {
        if (a - b < 0) {
          return Math.abs((a - b - (c - d)) / (a - b));
        } else {
          return Math.abs((c - d) / (a - b));
        }
      }
    }
  }
  return data;
};

export const fillData = (
  data,
  { date, data2_1, data2_2, data2_3, dataLast2_1 = [] },
) => {
  // 右侧整年数据自动填充上月已填写
  // 整年预测数据从2-1 2-2 2-3 获取，所以无需使用上月数据
  // if (x.data.lastData && x.data.lastData.length > 0) {
  //     let lastData = x.data.lastData;
  //     const listName = ['whole_actual', 'whole_budget', 'whole_last_year', 'whole_actual_budget', 'whole_actual_last_year'];
  //     lastData.forEach((item, i) => {
  //         listName.forEach(name => {
  //             if (data[i][name] == 0) {
  //                 data[i][name] = item[name];
  //             }
  //         });
  //     });
  // }

  // 后三个月数据从2——1获取,后三个月预测等于2.1后面三个月的总和
  dataLast2_1 =
    _.get(dataLast2_1, "0.month") == moment(date).format("M")
      ? dataLast2_1
      : dataLast2_1.map((v) => ({ ...v, Jan: v["nextJan"] }));

  let month = Number(moment(date).format("MM") || "0");
  const listName = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dataName = [...listName].splice(month, 3);
  const nextName = ["nextJan", "nextFeb", "nextMar"];
  // 如果月份大于九月份，后三个月预测数据加上下一年预测数据
  if (dataName.length < 3) {
    dataName = [...dataName, ...nextName.slice(0, 3 - dataName.length)];
  }

  data.forEach((item, i) => {
    // 2-1
    if (
      (data2_1 && data2_1.length > 0) ||
      (dataLast2_1 && dataLast2_1.length)
    ) {
      if (i < 24) {
        // 实际与预测 、全年实际
        data[i].actual = getJson([i + 1, listName[month - 1]], data2_1, 0);
        if (month == 1) {
          data[i].prediction = getJson([i + 1, "nextJan"], dataLast2_1, 0);
        } else
          data[i].prediction = getJson(
            [i + 1, listName[month - 1]],
            dataLast2_1,
            0,
          );

        data[i].year_actual = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i + 1, b], data2_1, 0));
            }
            return a;
          }, 0)
          .toFixed(2);
        // 后三个月预测
        data[i].three_actual = dataName
          .reduce((a, b) => {
            a += Number(getJson([i + 1, b], data2_1));
            return a;
          }, 0)
          .toFixed(2);
        // 整年预测
        data[i].whole_actual = listName
          .reduce((a, b) => {
            a += Number(getJson([i + 1, b], data2_1));
            return a;
          }, 0)
          .toFixed(2);
      }
      if (i > 24) {
        // 实际与预测
        data[i].actual = getJson([i, listName[month - 1]], data2_1, 0);
        if (month == 1) {
          data[i].prediction = getJson([i, "nextJan"], dataLast2_1, 0);
        } else
          data[i].prediction = getJson(
            [i, listName[month - 1]],
            dataLast2_1,
            0,
          );

        data[i].three_actual = dataName
          .reduce((a, b) => {
            a += Number(getJson([i, b], data2_1, 0));
            return a;
          }, 0)
          .toFixed(2);
        data[i].whole_actual = listName
          .reduce((a, b) => {
            a += Number(getJson([i, b], data2_1, 0));
            return a;
          }, 0)
          .toFixed(2);
        data[i].year_actual = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i, b], data2_1, 0));
            }
            return a;
          }, 0)
          .toFixed(2);
      }
    }
    // 2-2
    if (data2_2 && data2_2.length > 0) {
      if (i < 24) {
        // MTD、YTD 预算
        data[i].budget = getJson([i + 1, listName[month - 1]], data2_2, 0);
        data[i].year_budget = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i + 1, b], data2_2, 0));
            }
            return a;
          }, 0)
          .toFixed(2);

        data[i].three_budget = dataName
          .reduce((a, b) => {
            a += Number(data2_2[i + 1][b]);
            return a;
          }, 0)
          .toFixed(2);

        data[i].whole_budget = listName
          .reduce((a, b) => {
            a += Number(data2_2[i + 1][b]);
            return a;
          }, 0)
          .toFixed(2);
      }
      if (i > 24) {
        // MTD、YTD 预算
        data[i].budget = getJson([i, listName[month - 1]], data2_2, 0);
        data[i].year_budget = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i, b], data2_2, 0));
            }
            return a;
          }, 0)
          .toFixed(2);
        data[i].three_budget = dataName
          .reduce((a, b) => {
            a += Number(data2_2[i][b]);
            return a;
          }, 0)
          .toFixed(2);
        data[i].whole_budget = listName
          .reduce((a, b) => {
            a += Number(data2_2[i][b]);
            return a;
          }, 0)
          .toFixed(2);
      }
    }
    // 2-3
    if (data2_3 && data2_3.length > 0) {
      if (i < 24) {
        // MTD、YTD 去年实际
        data[i].last_year = getJson([i + 1, listName[month - 1]], data2_3, 0);
        data[i].year_last_year = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i + 1, b], data2_3, 0));
            }
            return a;
          }, 0)
          .toFixed(2);
        data[i].three_last_year = dataName
          .reduce((a, b) => {
            a += Number(data2_3[i + 1][b]);
            return a;
          }, 0)
          .toFixed(2);
        data[i].whole_last_year = listName
          .reduce((a, b) => {
            a += Number(data2_3[i + 1][b]);
            return a;
          }, 0)
          .toFixed(2);
      }
      if (i > 24) {
        // MTD、YTD 去年实际
        data[i].last_year = getJson([i, listName[month - 1]], data2_3, 0);
        data[i].year_last_year = [...listName]
          .reduce((a, b, index) => {
            if (index < month) {
              a += Num(getJson([i, b], data2_3, 0));
            }
            return a;
          }, 0)
          .toFixed(2);
        data[i].three_last_year = dataName
          .reduce((a, b) => {
            a += Number(data2_3[i][b]);
            return a;
          }, 0)
          .toFixed(2);
        data[i].whole_last_year = listName
          .reduce((a, b) => {
            a += Number(data2_3[i][b]);
            return a;
          }, 0)
          .toFixed(2);
      }
    }
  });
  return data;
};

export const saveAllData = async (date) => {
  // 获取所有酒店
  const {
    data: { hotels },
  } = await request("/getHotels");
  for (let i = 0; i < hotels.length; i++) {
    const item = hotels[i];
    //  获取当前酒店数据
    let data = _.cloneDeep(data1_1);
    const { data: x } = await request(
      `/kpiInfoAll?year=${moment(date).format("YYYY")}&month=${moment(date).format("M")}&comid=${item.id}`,
    );
    if (x.kpi && x.kpi.length > 0) {
      data = x.kpi;
    }
    data = compute(fillData(data, { ...x, date }));
    let year = moment(date).format("YYYY");
    let month = moment(date).format("M");
    let _data = data.map((x) => ({ ...x, year, month, comid: item.id }));
    let dataFrom = new FormData();
    dataFrom.append("data", JSON.stringify(_data));
    let headres = {
      method: "post",
      credentials: "include",
      headers: {},
      body: dataFrom,
    };
    await request("/addKpiInfo", headres);
  }
  message.success("保存成功！");
};



// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-1KeyPerformanceIndicator/compute.js